<div class="subdetails-container">
    <h2 class="subdetails-title">Subscription Details</h2>
    <div class="subdetails-content">
        <div>
            <h3>{{name}}</h3>
            <p style="color: #7c7c7c;">{{email}}</p>
        </div>
        <p class="plan-details">You're currently on the Free plan</p>
        <button class="btn btn-primary btn-sm" (click)="onUpgrade()">Upgrade plan</button>
    </div>
</div>
